const uploadHelper = {
  protoFileType (type) {
    const mime = type.split('/')
    switch (mime[0]) {
      case 'text':
        return 0
      case 'image':
        return 3
      case 'audio':
        return 1
      case 'video':
        return 2
      case 'application':
        if (mime[1] === 'zip' || mime[1].includes('compressed')) return 4
        return 0
      default:
        return 0
    }
  }
}

export default uploadHelper
